function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Delivery = function Delivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M9.61 19.15h5.34a2.78 2.78 0 0 0 2.68 2.04 2.79 2.79 0 0 0 2.68-2.04h1.63v.01c.41 0 .75-.34.75-.75v-6.17c0-.45-.11-.89-.32-1.29l-2.08-3.91a2.75 2.75 0 0 0-2.43-1.46h-3.78V4.56c0-.96-.79-1.75-1.75-1.75H3.06c-.96 0-1.75.79-1.75 1.75V17.4c0 .96.79 1.75 1.75 1.75h1.19a2.79 2.79 0 0 0 2.68 2.04 2.79 2.79 0 0 0 2.68-2.04m-.006-1.5h2.966v-4.54H2.81v4.29c0 .14.11.25.25.25h1.196a2.79 2.79 0 0 1 2.674-2.02 2.79 2.79 0 0 1 2.674 2.02m-3.954.762v-.024a1.28 1.28 0 0 1 1.28-1.268c.7 0 1.28.58 1.28 1.28s-.58 1.28-1.28 1.28a1.29 1.29 0 0 1-1.28-1.268m13.26-.018v.012a1.29 1.29 0 0 1-1.28 1.274c-.7 0-1.28-.58-1.28-1.28s.57-1.28 1.28-1.28a1.29 1.29 0 0 1 1.28 1.274m1.394-.744h.886v-5.42c0-.2-.05-.41-.15-.59l-2.08-3.91c-.22-.41-.64-.66-1.1-.66h-3.78v10.58h.876a2.79 2.79 0 0 1 2.674-2.02 2.79 2.79 0 0 1 2.674 2.02M12.57 6.33v5.28H2.81V4.56c0-.14.11-.25.25-.25h9.27c.14 0 .25.11.25.25V6.21a1 1 0 0 0-.01.121",
    clipRule: "evenodd"
  }));
};
export default Delivery;
Delivery.displayName = 'Delivery';